// eslint-disable-next-line import/prefer-default-export
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
